import React from "react"

import Item from "./item";

class items extends React.Component
{
    displayable = (item) => {
        let result = item.display.indexOf("Mobile") >= 0;
        result &= this.props?.onPermitted ? this.props.onPermitted(item.permissions) : true;
        return result;
    }

    render() {
        return (
            (!this.props.items?.length) ?  `` :
            this.props.items.map((item, index) => {
                return (this.displayable(item)) ? <Item onPermitted={ this.props.onPermitted } key={`menu.${item.id}.${index}`} id={item.id} item={item} /> : null
            })
        )
    }
}
    
export default items;
